import EntryTypeGrid from "../home/EntryTypeGrid";
import { BsFiles } from "react-icons/bs";
import PageLayout from "../common/PageLayout";
import { useLocation } from "react-router-dom";

export default function NewEntry() {
  const location = useLocation();

  return (
    <PageLayout title="Ново барање" Icon={BsFiles} prev={location.pathname}>
      <EntryTypeGrid />
    </PageLayout>
  );
}
